import lionsLogo from "../assets/lionsLogo.png";
import fbLogo from "../assets/fbLogo.png";
import instaLogo from "../assets/instaLogo.png";
import useSeasonDetails from "../hooks/useSeasonDetails";
import ContactsList from "./ContactsList";

function getImpressumContacts(data) {
    const bands = data?.pages?.Impressum?.bands;
    if (!Array.isArray(bands)) return [];
    for (const band of bands) {
        for (const section of band.sections || []) {
            if (Array.isArray(section.contacts)) return section.contacts;
        }
    }
    return [];
}

function Footer() {
    const { data } = useSeasonDetails();
    const contacts = getImpressumContacts(data);

    return (
        <div className="relative z-50 w-4/5 m-auto pt-24 md:pt-32 lg:pt-40 pb-16">

            <div className="flex flex-col lg:flex-row justify-between text-white md:text-2xl sm:text-1xl">
                <div className="mb-10">

                    <div className="mb-5 font-bold">Kontakte</div>
                    <ContactsList contacts={contacts} variant="dark" />

                </div>
                
                <div className="mb-10">
                    <div className="font-bold mb-4">Spendenkonto</div>
                    <div>LIONS Club Hilfswerk</div>
                    <div>Jugendförderung Dresden Agenda 21 e.V.</div>
                    <div>Commerzbank Dresden</div>
                    <div>IBAN: DE39 8504 0000 0145 5450 01</div>
                    <div>BIC: COBADEFFXXX</div>
                    <div>Stichwort: “{data?.["entencup-number"]}. Dresdner Entencup”</div>
                </div>

                <div className="mb-10">
                    <div className="font-bold mb-2">Social Media</div>
                    <div className="flex">
                        <a href="https://en-gb.facebook.com/pg/entencup" target="_blank" rel="noreferrer">
                            <div><img src={fbLogo} height={50} width={50} alt="Facebook Link" /></div>
                        </a>
                        <a className="ml-4 mt-1" target="_blank" href="https://www.instagram.com/explore/tags/entencup/" rel="noreferrer">
                            <div><img height={40} width={40} src={instaLogo} alt="Instagram Link" /></div>
                        </a>
                    </div>
                </div>

                <div className="text-blue-light">
                    <div className="pb-4">
                        <a href="/impressum">Impressum</a>
                    </div>
                    <div className="">
                        <a href="/datenschutz">Datenschutz</a>
                    </div>
                </div>
            </div>


            <div className="mt-24 flex flex-col lg:flex-row text-white md:text-2xl sm:text-1xl items-center text-center md:text-left">
                <div>
                    <img src={lionsLogo} alt="lions logo" className="w-28" />
                </div>
                <div className="md:pl-8">
                    <div className="font-bold">
                        LIONS Club Hilfswerk
                    </div>
                    <div className="font-bold">
                        Jugendförderung Dresden Agenda 21 e.V.
                    </div>
                    <div>
                        c/o Detlef U. Müller-Greven
                    </div>
                    <div>
                        Anton-Graff-Straße 29, 01309 Dresden, Tel. 0351/44866-0
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;
